import { Component, OnInit, ElementRef } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import {  ViewChild } from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';


declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
import { MatTabChangeEvent } from '@angular/material';

@Component({
  selector: 'app-places',
  templateUrl: './places.component.html',
  styleUrls: ['./places.component.css']
})
export class PlacesComponent implements OnInit {


      meetingrooms:MeetingRooms[];
      user:Object;
      public available_rooms:number;
      public submitted:boolean;
      public license_expired:boolean;
      authURL;
      room_count;
      Account_data;

      //ngmodel field names
      room_name_field;
      room_type_field;
      floor_number_field;

      cookieExsists:boolean;
      selectedTab;

      constructor(private authService:AuthenticationService, private cookieService:CookieService , private route: ActivatedRoute,private _flashMessagesService: FlashMessagesService,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {}
      ngOnInit() {

        this.submitted=true;
        this.setRoomOutlookURL();
        this.refreshEverything();

        this.cookieExsists = this.cookieService.check('room_name');
        //console.log("Cookie Exsist? " ,this.cookieExsists);
        if(this.cookieExsists){
          this.selectedTab =1;
        }


        
        this.room_name_field = this.cookieService.get('room_name');
        this.room_type_field = this.cookieService.get('room_type');
        this.floor_number_field = this.cookieService.get('floor_number');


        ////console.log(value);
      }

      setRoomOutlookURL = () => {
      
        this.getdataService.getAuthURL().subscribe((authURL) => {
          ////console.log(authURL);
          this.authURL = authURL
          //  this.submitted=false;
        },
        err=>{
          return false;
        });
      }

      roomParametersToCookies = () =>{
      
        let room_name = this.elem.nativeElement.querySelector('#roomname').value;
        let room_type = this.elem.nativeElement.querySelector('#roomtype').value;
        let floor_number = this.elem.nativeElement.querySelector('#floornumber').value;
        this.cookieService.set( 'room_name', room_name );
        this.cookieService.set( 'room_type', room_type );
        this.cookieService.set( 'floor_number', floor_number );

      }



      tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
        ////console.log(this.cookieService.get('room_name'))
        //console.log(tabChangeEvent.index)

    }

  refreshEverything = ()=>{
    
    ////////refresh meeting rooms /////////////
    this.authService.getProfile().subscribe((user) => {
      this.user=  user;
      //////console.log(this.user[0].user.account_ID);

      this.getdataService.getAccountNameById(this.user[0].user.account_ID).subscribe((account_data) => {
      
        this.Account_data = account_data[0];
        //console.log("outlook",  this.Account_data.feature_outlook)
        //console.log("calendar",  this.Account_data.feature_google_calendar)
      },
      err=>{
        //////console.log(err);
        return false;
      });

      if(this.user[0].user.isSuperAdmin)
      {
        this.getdataService.getAllMeetingRooms().subscribe((meetingrooms) => {
          this.meetingrooms=  meetingrooms;
          //////console.log(this.meetingrooms);
          //   this.available_rooms = this.user[0].user.max_number_of_rooms - this.meetingrooms.length;
          //   if(this.available_rooms ==0){
          //   this.license_expired=true;
         
          // }else{
            this.license_expired=false;
         // }
          this.submitted=false;
        },
      err=>{
        //////console.log(err);
        return false;
      });
      }else{
        this.getdataService.getMeetingRoomsByAccount(this.user[0].user.account_ID).subscribe((meetingrooms) => {
          this.meetingrooms=  meetingrooms;
          ////console.log(this.user[0].user.account_ID)
          this.getdataService.getRoomCountByAccountID(this.user[0].user.account_ID).subscribe((room_count) => {
            ////console.log(room_count)
            
            this.available_rooms = room_count[0].licensed_rooms - this.meetingrooms.length;
            if(this.available_rooms ==0){
            this.license_expired=true;
  
          }else{
            this.license_expired=false;
          }
          this.submitted=false;
              },
            err=>{
              //////console.log(err);
              return false;
            });
          //////console.log(this.meetingrooms);
          
        },
      err=>{
        //////console.log(err);
        return false;
      });
      }
     



    },
  err=>{
    //////console.log(err);
    return false;
  });




    //////////end refresh meeting rooms.////////
    }

  deleteRoom = function(deletedRoomID,deletedRoomName,RoomDefaultLogo) {
         if(confirm('Are you sure you want to delete "'+deletedRoomName+'"?')) {
         this.submitted=true;
         this.deletedataService.deleteRoom(deletedRoomID,deletedRoomName,RoomDefaultLogo).subscribe((res:Response)=>{

               ////////refresh category /////////////
               this.refreshEverything();
             //////////end refresh category.////////
              this.submitted=false;
       });
    }
  }


  ///public addRoom(): void{
    addOutlookRoom = function(){
      

      ///to be modified

      //this.cookieService.deleteAll();
      this.submitted=true;
         let files = this.elem.nativeElement.querySelector('#image_roomlogo_outlook').files;
         

        //  let room_name = this.elem.nativeElement.querySelector('#roomname').value;
        //  let room_type = this.elem.nativeElement.querySelector('#roomtype').value;
        //  let floor_number = this.elem.nativeElement.querySelector('#floornumber').value;
         let formData = new FormData();
     
         let file = files[0];
         formData.append('image',file,file.name);
         formData.append('room_name',this.room_name_field);
         formData.append('room_type',this.room_type_field);
         formData.append('room_floor_number',this.floor_number_field);
         formData.append('room_outlook_ID',this.room_outlook_ID);
         formData.append('room_account_ID',this.user[0].user.account_ID);
         formData.append('graph_access_token',this.cookieService.get('graph_access_token'));
         formData.append('graph_refresh_token',this.cookieService.get('graph_refresh_token'));
         formData.append('graph_token_expires',this.cookieService.get('graph_token_expires'));
         formData.append('graph_user_name',this.cookieService.get('graph_user_name'));
         this.cookieService.deleteAll();
         this.adddataService.addOutlookRoom(formData).subscribe
         (res =>{
               this._flashMessagesService.show('Success: Room added successfully', {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});
     
               ////////refresh category /////////////
                    this.refreshEverything();
                    this.submitted=false;
     
             //////////end refresh category.////////
          
           this.cookieExsists = this.cookieService.check('room_name');
     
       } );
     
       }


  ///public addRoom(): void{
addRoom = function(){
 this.submitted=true;
    let files = this.elem.nativeElement.querySelector('#image_roomlogo').files;
    let room_name = this.elem.nativeElement.querySelector('#roomname').value;
    let room_type = this.elem.nativeElement.querySelector('#roomtype').value;
    let floor_number = this.elem.nativeElement.querySelector('#floornumber').value;
    let formData = new FormData();

    let file = files[0];
    formData.append('image',file,file.name);
    formData.append('room_name',room_name);
    formData.append('room_type',room_type);
    formData.append('room_floor_number',floor_number);
    formData.append('room_account_ID',this.user[0].user.account_ID);

    this.adddataService.addRoom(formData).subscribe
    (res =>{
          this._flashMessagesService.show('Success: Room added successfully', {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

          ////////refresh category /////////////
               this.refreshEverything();
               this.submitted=false;

        //////////end refresh category.////////

  } );

  }


}




interface MeetingRooms{
  _id:number,
  room_name:string,
  room_place:string,
  room_default_logo:string,
  room_default_logo_path:string,
  room_type:string,
  room_floor_number:string,
  room_slider_ID:string
}


interface User{
  _id:number,
  account_ID:string
}



// WEBPACK FOOTER //
// ./src/app/components/places/places.component.ts